import { ApolloClient } from 'apollo-client';
import { from } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

import {
  FileUploadLinkMid,
  setAuthHeaderMid,
  showProgressBarMid,
  hideProgressBarAfter,
} from './apolloLinks';


const apiRootUrl = process.env.REACT_APP_STARGATE_ROOT_URL;
const gqlEndpointUrl = apiRootUrl + '/api/graphql';


/*
 * Link, network layer
 */
const httpLink = new HttpLink({
  uri: gqlEndpointUrl,
});


/*
 * Cache, data layer
 */
const cache = new InMemoryCache({
  dataIdFromObject: (result) => {
    if (result.id && result.__typename) {
      return `${result.__typename}:${result.id}`;
    }

    // Make sure to return null if this object doesn't have an ID
    return null;
  },
});


/*
 * Init apollo client w/ link and cache
 */
const middlewares = [
  setAuthHeaderMid,
  showProgressBarMid,
  FileUploadLinkMid({ uri: gqlEndpointUrl }),
];


export default () => {
  const client = new ApolloClient({
    link: from([
      ...middlewares,
      hideProgressBarAfter,
      httpLink,
    ]),
    cache,
  });

  return client;
};



// WEBPACK FOOTER //
// ./src/helpers/initApolloClient.js